import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import Buttons from '../Components/Buttons'
import { ROUTER } from '../router/constants'
import DatePicker from '../Components/DatePicker'
import { useNavigate } from 'react-router-dom'
import moment from 'jalali-moment'

const Date = () => {

    const navigate = useNavigate()

    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

    const [completeDate, setCompleteDate] = useState(moment().format('jYYYY/jMM/jDD'));
    const [selectedWeekday, setSelectedWeekday] = useState(
        (() => {
            const today = moment();
            const weekdays = [
                'شنبه', 'یک‌شنبه', 'دو‌شنبه', 'سه‌شنبه',
                'چهار‌شنبه', 'پنج‌شنبه', 'جمعه'
            ];
            return weekdays[today.jDay()];
        })()
    );

    const handleCheck = () => {
        if (completeDate) {
            localStorage.setItem('completeDate', completeDate);
            localStorage.setItem('selectedWeekday', selectedWeekday);
            navigate(ROUTER.RESERVE_ROOM_TIME)
        }
    };

    return (
        <div className='container' style={{ padding:isLargeScreen? '60px 40px':'30px 20px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant={isLargeScreen ? 'h1' : 'h2'} align="center" color='black' sx={{ fontWeight: isLargeScreen ? 600 : 700, color: 'black', mb: '64px' }}>
                انتخاب تاریخ
            </Typography>
            <Box sx={{mb:"64px"}}>
                <Typography
                    color={theme.palette.info.dark}
                    variant={isLargeScreen ? 'h5' : 'h6'}
                    align="center"
                    sx={{
                        mb: '20px'
                    }}
                >
                    تاريخ مورد نظر خود را انتخاب نماييد
                </Typography>
                <Grid>
                    <DatePicker
                        completeDate={completeDate}
                        setCompleteDate={setCompleteDate}
                        selectedWeekday={selectedWeekday}
                        setSelectedWeekday={setSelectedWeekday}
                    />
                </Grid>
            </Box>
            <Buttons backTitle={'بازگشت'} checkTitle={'ثبت'} backLink={ROUTER.HOME} checkLink={''} onCheck={handleCheck} />
        </div>
    )
}

export default Date
